import React from 'react';
import PropTypes from 'prop-types';
import { Text } from '@nerdwallet/react-typography';
import { formatCurrency } from '@nerdwallet/nw-client-lib/num';

var OptionsBrokerFeeCaption = function OptionsBrokerFeeCaption(_ref) {
  var data = _ref.data;
  var optionsContractPrice = data.optionsContractPrice,
      tradeFeeCaption = data.tradeFeeCaption;
  var caption = tradeFeeCaption;

  if (optionsContractPrice) {
    caption = "".concat(tradeFeeCaption, ", + ").concat(formatCurrency(optionsContractPrice, true), "/contract");
  }

  return React.createElement("span", {
    className: "annotation"
  }, React.createElement(Text, {
    small: true
  }, caption));
};

OptionsBrokerFeeCaption.propTypes = {
  data: PropTypes.object
};
export default OptionsBrokerFeeCaption;